var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._l((_vm.contentBlocks),function(block,index){return [(block.is === _vm.LINE_BREAK_BLOCK_TYPES.nobr)?_c('span',{key:("nobr-" + index),staticClass:"u-nobr"},[_vm._v(_vm._s(block.value))]):[_vm._v(_vm._s(block.value)+" ")]]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }